'use client';

import React from 'react';
import AppIcon from '@/components/ui/AppIcon';
import { useNotifications, type ToastItem } from '@/lib/notificationContext';

const VARIANT_STYLES: Record<ToastItem['variant'], { bg: string; border: string; icon: string; iconColor: string }> = {
  success: { bg: 'bg-white', border: 'border-green-200', icon: 'CheckCircleIcon', iconColor: 'text-green-600' },
  warning: { bg: 'bg-white', border: 'border-amber-200', icon: 'ExclamationTriangleIcon', iconColor: 'text-amber-500' },
  info: { bg: 'bg-white', border: 'border-blue-200', icon: 'InformationCircleIcon', iconColor: 'text-blue-500' },
  error: { bg: 'bg-white', border: 'border-red-200', icon: 'XCircleIcon', iconColor: 'text-red-500' },
};

export default function ToastStack() {
  const { toasts } = useNotifications();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-2 pointer-events-none" style={{ maxWidth: 360 }}>
      {toasts.map(toast => {
        const style = VARIANT_STYLES[toast.variant];
        return (
          <div
            key={toast.id}
            className={`pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg border ${style.bg} ${style.border} animate-slide-in`}
          >
            <AppIcon name={style.icon} size={18} className={`${style.iconColor} shrink-0 mt-0.5`} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-600 text-foreground leading-tight">{toast.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5 leading-snug">{toast.message}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
